













































































































































import Vue from "vue";
import * as SwalUtils from "./utils/SwalUtils";

import EhrButton from "./interface/EhrButton.vue";
import { RepositoryFactory } from "./repositories/RepositoryFactory";
import { email, required } from "vuelidate/lib/validators";
const UserRepository = RepositoryFactory.get("user");
declare var GLOBAL_logo: string;
declare var GLOBAL_applicationName: string;
declare var forgToken: string;

export default Vue.extend({
  name: "login-component",
  components: { EhrButton },
  data() {
    return {
      username: "",
      password: "",
      resetEmail: "",
      token: forgToken,
      loading: false,
      iconText: "eye",
      isPasswordVisible: false,
      logo: GLOBAL_logo,
      isPasswordBeingReset: false,
    };
  },
  computed: {
    applicationName() {
      return GLOBAL_applicationName;
    },
  },
  methods: {
    async doLogin() {
      var formTest = new FormData();
      this.loading = true;
      formTest.append("username", this.username);
      formTest.append("password", this.password);
      const res = await UserRepository.login(formTest, {
        headers: {
          RequestVerificationToken: this.token,
        },
      })
        .then(function(res) {
          window.location.href = document.baseURI + "Home";
        })
        .catch(function(err) {
          SwalUtils.DisplayLoginErrorAlert();
        });
      this.loading = false;
    },
    togglePasswordVisibility(): void {
      this.iconText == "eye"
        ? (this.iconText = "eye-slash")
        : (this.iconText = "eye");
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    showForgotPassword(): void {
      this.isPasswordBeingReset = true;
    },
    hideForgotPassword(): void {
      this.isPasswordBeingReset = false;
      this.reset();
    },
    reset(): void {
      this.resetEmail = "";
      this.username = "";
      this.password = "";
      this.isPasswordBeingReset = false;
    },
    async requestNewPasswordForEmail() {
      const res = await UserRepository.requestNewPassword(this.resetEmail)
        .then(function(res) {
          SwalUtils.DisplaySuccessToast(
            "Er werd een mail verzonden met verdere instructies."
          );
        })
        .catch(function(err) {
          SwalUtils.DisplayErrorToast("Er is iets foutgelopen.");
        });
      this.reset();
    },
  },
  validations() {
    return {
      resetEmail: {
        email,
        required,
      },
    };
  },
});
